import React from 'react';
import { useTranslation } from 'react-i18next';
import StatCard from '../../StatCard';
import {
  MenuBook,
  Timer,
  CheckCircle,
  Error,
  ExitToApp,
} from '@mui/icons-material';

interface KPIData {
  totalSessions: number;
  averageDuration: number;
  averageAccuracy: number;
  systemCrashRate: number;
  abandonmentRate: number;
  completedSessions: number;
  crashedSessions: number;
  abandonedSessions: number;
}

interface ReadingSessionsKPIsProps {
  kpis: KPIData | null;
  isLoading: boolean;
}

const ReadingSessionsKPIs: React.FC<ReadingSessionsKPIsProps> = ({ kpis, isLoading }) => {
  const { t } = useTranslation();

  return (
    <div className="statisticsSection">
      <div className="statisticsGrid">
        <StatCard
          title={t('totalSessions')}
          value={kpis?.totalSessions || 0}
          icon={<MenuBook />}
          variant="primary"
          isLoading={isLoading}
        />
        <StatCard
          title={t('averageDuration')}
          value={kpis?.averageDuration ? `${kpis.averageDuration} ${t('minutes')}` : '0'}
          icon={<Timer />}
          variant="purple"
          isLoading={isLoading}
        />
        <StatCard
          title={t('averageAccuracy')}
          value={kpis?.averageAccuracy ? `${kpis.averageAccuracy}%` : '0%'}
          icon={<CheckCircle />}
          variant="success"
          isLoading={isLoading}
        />
        <StatCard
          title={t('systemCrashRate')}
          value={kpis?.systemCrashRate ? `${kpis.systemCrashRate}%` : '0%'}
          icon={<Error />}
          variant={kpis && kpis.systemCrashRate > 5 ? 'red' : 'orange'}
          isLoading={isLoading}
        />
        <StatCard
          title={t('abandonmentRate')}
          value={kpis?.abandonmentRate ? `${kpis.abandonmentRate}%` : '0%'}
          icon={<ExitToApp />}
          variant="purple"
          isLoading={isLoading}
        />
      </div>
    </div>
  );
};

export default ReadingSessionsKPIs;

